export default [
  // 选课中心
  {
    path: '/course',
    name: 'courseSelect',
    meta: { title: "选课中心" },
    component: () => import('@/views/pages/courseSelect/index.vue')
  },
  // 学习中心
  {
    path: '/course/:courseID',
    component: () => import('@/views/pages/course/index.vue'),
    redirect: '/course/:courseID',
    children: [
      {
        path: 'catalogue',
        name: 'catalogue',
        component: () => import('@/views/pages/course/catalogue.vue')
      },
      {
        path: 'homework',
        name: 'homework',
        component: () => import('@/views/pages/course/homework.vue')
      },
      {
        path: 'video',
        name: 'video',
        component: () => import('@/views/pages/course/video.vue')
      },
      {
        path: 'summary',
        name: 'summary',
        component: () => import('@/views/pages/course/summary.vue')
      },
      {
        path: 'notification',
        name: 'notification',
        component: () => import('@/views/pages/course/notification.vue')
      },
      {
        path: '',
        name: 'catalogue',
        component: () => import('@/views/pages/course/catalogue.vue')
      },
      {
        path: 'grade',
        name: 'grade',
        component: () => import('@/views/pages/course/grade.vue')
      },
      {
        path: 'note',
        name: 'note',
        component: () => import('@/views/pages/course/note.vue')
      },
      {
        path: 'signin',
        name: 'signin',
        component: () => import('@/views/pages/course/signin.vue')
      },
      // {
      //   path: 'group',
      //   component: () => import('@/views/pages/course/group/index.vue'),
      //   redirect: '/course/:courseID/group/all',
      //   children: [
      //     {
      //       path: 'all',
      //       component: () => import('@/views/pages/course/group/all.vue')
      //     },
      //     {
      //       path: 'my',
      //       component: () => import('@/views/pages/course/group/my.vue')
      //     },
      //     {
      //       path: 'create',
      //       component: () => import('@/views/pages/course/group/create.vue')
      //     }
      //   ]
      // },
      {
        path: 'exam',
        name: 'exam',
        component: () => import('@/views/pages/course/exam.vue')
      }
    ]
  },

  {
    path: '/course/:courseID/rank',
    name: 'rank',
    meta: { title: "完成度排行" },
    component: () => import('@/views/pages/course/rank.vue')
  },
  {
    path: '/course/:courseID/point',
    name: 'point',
    meta: { title: "积分排行" },
    component: () => import('@/views/pages/course/point.vue')
  },


  // 正在上课
  {
    path: '/studying/:courseID/:chapterID/:sectionID',
    name: 'title',
    meta: { title: "正在上课" },
    component: () => import('@/views/pages/course/section/studying.vue')
  },
  {
    path: '/studying/:courseID/:chapterID/:sectionID/title',
    name: 'title',
    meta: { title: "正在上课" },
    component: () => import('@/views/pages/course/section/studying'),
  },
  {
    path: '/studying/:courseID/:chapterID/:sectionID/solution',
    name: 'solution',
    meta: { title: "正在上课" },
    component: () => import('@/views/pages/course/section/studying'),
  },
  {
    path: '/studying/:courseID/:chapterID/:sectionID/result',
    name: 'result',
    meta: { title: "正在上课" },
    component: () => import('@/views/pages/course/section/studying'),
  },
  {
    path: '/studying/:courseID/:chapterID/:sectionID/submissions',
    name: 'submissions',
    meta: { title: "正在上课" },
    component: () => import('@/views/pages/course/section/studying'),
  },
  // 课程内容
  {
    path: '/course/:courseID/:chapterID/:sectionID',
    name: 'title',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/course/section/index'),
  },
  {
    path: '/course/:courseID/:chapterID/:sectionID/title',
    name: 'title',
    meta: { title: "题目描述" },
    component: () => import('@/views/pages/course/section/index'),
  },
  {
    path: '/course/:courseID/:chapterID/:sectionID/solution',
    name: 'solution',
    meta: { title: "题解" },
    component: () => import('@/views/pages/course/section/index'),
  },
  {
    path: '/course/:courseID/:chapterID/:sectionID/result',
    name: 'result',
    meta: { title: "运行结果" },
    component: () => import('@/views/pages/course/section/index'),
  },
  {
    path: '/course/:courseID/:chapterID/:sectionID/submissions',
    name: 'submissions',
    meta: { title: "提交记录" },
    component: () => import('@/views/pages/course/section/index'),
  },
  // 课程作业
  {
    path: '/coursehw/:courseID/:chapterID/:sectionID',
    name: 'section',
    component: () => import('@/views/pages/course/section/index'),
    redirect: '/course/:courseID/:chapterID/:sectionID',
    children: [
      {
        path: '',
        name: '',
        meta: { title: "题目描述" },
        component: () => import('@/views/pages/problem/problem/7_code/title.vue'),
      },
      {
        path: 'comments',
        name: 'comments',
        meta: { title: "评论" },
        component: () => import('@/views/pages/problem/problem/7_code/comments.vue'),
      },
      {
        path: 'solution',
        name: 'solution',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/solution.vue'),
      },
      {
        path: 'result',
        name: 'result',
        meta: { title: "运行结果" },
        component: () => import('@/views/pages/problem/problem/7_code/result.vue'),
      },
      {
        path: 'submissions',
        name: 'submissions',
        meta: { title: "提交记录" },
        component: () => import('@/views/pages/problem/problem/7_code/submissions.vue'),
      }
    ]
  },
  // 课程内容 教师
  {
    path: '/courseteach/:courseID/:chapterID/:sectionID',
    name: 'section',
    component: () => import('@/views/pages/course/section/index'),
    redirect: '/course/:courseID/:chapterID/:sectionID',
    children: [
      {
        path: '',
        name: '',
        meta: { title: "题目描述" },
        component: () => import('@/views/pages/problem/problem/7_code/title.vue'),
      },
      {
        path: 'comments',
        name: 'comments',
        meta: { title: "评论" },
        component: () => import('@/views/pages/problem/problem/7_code/comments.vue'),
      },
      {
        path: 'solution',
        name: 'solution',
        meta: { title: "题解" },
        component: () => import('@/views/pages/problem/problem/7_code/solution.vue'),
      },
      {
        path: 'result',
        name: 'result',
        meta: { title: "运行结果" },
        component: () => import('@/views/pages/problem/problem/7_code/result.vue'),
      },
      {
        path: 'submissions',
        name: 'submissions',
        meta: { title: "提交记录" },
        component: () => import('@/views/pages/problem/problem/7_code/submissions.vue'),
      }
    ]
  },
  // 课程内容
  {
    path: '/course/:courseID/:info',
    name: 'courseSection',
    meta: { title: "学习课程" },
    redirect: '/course/:courseID',
    component: () => import('@/views/pages/course/index.vue'),
  },
]
